module.exports = __webpack_public_path__ + "img/hk-ico.bda72a2b.png";